import { createAction } from "redux-actions";
import moment from "moment";
import { apiGet } from "util/api";
import Immutable from "immutable";

import submissionPropsSelector from "./selectors";
import * as types from "./constants";

export const submissionDataFetchRequest = createAction(
  types.CTD_PROC_DATA_FETCH_REQUEST
);
export const submissionDataFetchError = createAction(
  types.CTD_PROC_DATA_FETCH_ERROR
);
export const submissionDataFetchSuccess = createAction(
  types.CTD_PROC_DATA_FETCH_SUCCESS
);

export const setRangeFilter = createAction(types.CTD_PROC_RANGE_FILTER);
export const setStageFilter = createAction(types.CTD_PROC_STAGE_FILTER);
export const setSearchFilter = createAction(types.CTD_PROC_SEARCH_FILTER);
export const setShowWirewalker = createAction(types.CTD_PROC_SHOW_WIREWALKER);

export const openDetailsModal = createAction(types.CTD_PROC_DETAILS_MODAL_OPEN);
export const closeDetailsModal = createAction(
  types.CTD_PROC_DETAILS_MODAL_CLOSE
);
export const setDetailsModalData = createAction(
  types.CTD_PROC_DETAILS_MODAL_SET_DATA
);

export const setSearchText = createAction(
  types.CTD_PROC_SET_FORM_DATA_SEARCH_TEXT
);

const submissionDataFetch = () => async (dispatch, getState) => {
  dispatch(submissionDataFetchRequest());

  const apiFilters = [];
  let dateFilter = "";

  const { rangeFilter, stageFilter, showWirewalker } = submissionPropsSelector(
    getState()
  );

  // Setup up minimum date to search in, translated from 'Select Range' select box
  if (rangeFilter) {
    // timeUnit is either 'Months' or 'Years'
    const [timeNumber, timeUnit] = rangeFilter.split(" ");
    const range = moment()
      .subtract(timeNumber, timeUnit)
      .format("YYYY-MM-DD");
    dateFilter = `start_dt>${range}`;
    apiFilters.push(dateFilter);
  }

  if (stageFilter) {
    if (stageFilter !== "Any") {
      apiFilters.push(`processing_stage=${stageFilter}`);
    }
  }

  if (showWirewalker) {
    apiFilters.push("is_wirewalker=true");
  } else {
    apiFilters.push("is_wirewalker!=true");
  }

  const fieldsToInclude = [
    "hakai_id",
    "start_dt",
    "ctd_file_pk",
    "processing_stage",
    "cruise",
    "station",
    "status",
    "start_depth",
    "bottom_depth",
    "target_depth",
    "no_cast",
    "process_error",
    "process_log",
    "filename",
    "device_model",
    "device_sn"
  ];
  try {
    const formSubmissions = await apiGet(
      `/ctd/views/file/cast?fields=${fieldsToInclude.join()}&limit=-1&sort=-start_dt&${apiFilters.join(
        "&"
      )}`
    ).then(res => res.json());

    dispatch(
      submissionDataFetchSuccess({
        formSubmissions
      })
    );
  } catch (err) {
    dispatch(submissionDataFetchError(err));
  }
};

export const submissionDataFetchIfNeeded = () => (dispatch, getState) => {
  const { isFetching } = submissionPropsSelector(getState());

  // refresh sub status table every time the view component loads- otherwise data remains when new user logs in
  if (isFetching !== true) {
    dispatch(submissionDataFetch());
  }
};

export const updateFiltersFromQuery = urlParams => async dispatch => {
  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of urlParams.entries()) {
    if (key === "rangeFilter") {
      dispatch(setRangeFilter(Immutable.fromJS(value)));
    } else if (key === "searchFilter") {
      dispatch(setSearchFilter(Immutable.fromJS(value)));
    } else if (key === "stageFilter") {
      dispatch(setStageFilter(Immutable.fromJS(value)));
    } else if (key === "showWirewalker") {
      dispatch(setShowWirewalker(Immutable.fromJS(value)));
    }
  }
};
